import React, { useEffect, useState } from "react";
import { Table, Button, Pagination } from "rsuite";

import "../../styles/Master.css";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../axiosInstance";

const { Column, HeaderCell, Cell } = Table;

function MeasurementTable({ referenceNumber }) {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);

  const handleChangeLimit = (dataKey) => {
    setPage(1);
    setLimit(dataKey);
  };

  const finalData = data.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  async function getInfo() {
    const result = await axiosInstance.post("/api/get-measurements-ref", {
      reference_number: referenceNumber,
    });
    const numbers = result.data;
    setData(numbers);
  }

  useEffect(() => {
    getInfo();
  }, []);

  return (
    <div className="master-display-table">
      <Table
        virtualized
        height={300}
        data={finalData}
        autoHeight={true}
        affixHeader
        affixHorizontalScrollbar
        rowHeight={50}
        headerHeight={30}
        onRowClick={(rowData) => {}}
      >
        <Column width={130} align="center" fixed>
          <HeaderCell>Reference Number</HeaderCell>
          <Cell dataKey="reference_number" />
        </Column>
        <Column width={130} resizable>
          <HeaderCell>Date</HeaderCell>
          <Cell dataKey="date" />
        </Column>

        <Column width={150} resizable>
          <HeaderCell>Length of Body (CDL)</HeaderCell>
          <Cell dataKey="lob_cdl" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Length of Body Anaethetised</HeaderCell>
          <Cell dataKey="lob_anaethetised" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Head Measurement (Between Eyes)</HeaderCell>
          <Cell dataKey="head_between_eyes" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>
            Head Measurement (From Base of Skull to Tip of Nose)
          </HeaderCell>
          <Cell dataKey="head_base_of_skull" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Length of Tail from Anus to Tip - Dorsal</HeaderCell>
          <Cell dataKey="lot_dorsal" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Length of Tail from Anus to Tip - Ventral</HeaderCell>
          <Cell dataKey="lot_ventral" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>
            Flesh Portion of Nose (Without Loss of Scales)
          </HeaderCell>
          <Cell dataKey="nose_without_loss_of_scales" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Flesh Portion of Nose (With Loss of Scales)</HeaderCell>
          <Cell dataKey="nose_with_loss_of_scales" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Girth at Last Set of Ribs</HeaderCell>
          <Cell dataKey="girth" />
        </Column>
        <Column width={120} resizable>
          <HeaderCell>Left Leg - Length</HeaderCell>
          <Cell dataKey="left_leg" />
        </Column>
        <Column width={120} resizable>
          <HeaderCell>Left Foot - Width</HeaderCell>
          <Cell dataKey="left_foot_width" />
        </Column>
        <Column width={120} resizable>
          <HeaderCell>Left Foot - Length</HeaderCell>
          <Cell dataKey="left_foot_length" />
        </Column>
        <Column width={120} resizable>
          <HeaderCell>Right Leg - Length</HeaderCell>
          <Cell dataKey="right_leg" />
        </Column>
        <Column width={120} resizable>
          <HeaderCell>Right Foot - Width</HeaderCell>
          <Cell dataKey="right_foot_width" />
        </Column>
        <Column width={120} resizable>
          <HeaderCell>Right Foot - Length</HeaderCell>
          <Cell dataKey="right_foot_length" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Scale Pattern - Dorsal Line Head to Tail</HeaderCell>
          <Cell dataKey="dorsal_scale_pattern" />
        </Column>
        <Column width={200} resizable>
          <HeaderCell>Scale Pattern - Ventral Line Head to Tail</HeaderCell>
          <Cell dataKey="ventral_scale_pattern" />
        </Column>

        <Column width={300} resizable>
          <HeaderCell>Other Observations</HeaderCell>
          <Cell dataKey="observations" />
        </Column>

        <Column width={160} fixed="right">
          <HeaderCell>...</HeaderCell>
          <Cell style={{ padding: "6px" }}>
            {(rowData) => (
              <div>
                <Button
                  appearance="link"
                  onClick={() =>
                    navigate(
                      `/physical-measurement/edit/${rowData.id}/${rowData.reference_number}`
                    )
                  }
                >
                  Edit
                </Button>
                <Button
                  appearance="link"
                  onClick={() => {
                    alert(`id:${rowData.idr}`);
                    const result = axiosInstance.post(
                      "/api/delete-measurement",
                      {
                        id: rowData.id,
                      }
                    );
                  }}
                >
                  Delete
                </Button>
              </div>
            )}
          </Cell>
        </Column>
      </Table>
      <div style={{ padding: 20 }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="xs"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={data.length}
          limitOptions={[20, 40, 80, 160, 300]}
          limit={limit}
          activePage={page}
          onChangePage={setPage}
          onChangeLimit={handleChangeLimit}
        />
      </div>
    </div>
  );
}

export default MeasurementTable;
